import React from "react";
import { useAuth } from "../../auth/useAuth";

interface RequireAdminProps {
  children: React.ReactNode;
}

export default function RequireAdmin({ children }: RequireAdminProps) {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <div className="text-sm text-muted-foreground animate-pulse">
          Checking admin access…
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
